const NODE_ENV = process.env.NODE_ENV;
const DATE_FORMAT = process.env.REACT_APP_DATE_FORMAT;
const DATE_TIME_FORMAT = process.env.REACT_APP_DATE_TIME_FORMAT;
const DISPLAY_DATE_FORMAT = process.env.REACT_APP_DISPLAY_DATE_FORMAT;
const DISPLAY_DATE_TIME_FORMAT = process.env.REACT_APP_DISPLAY_DATE_TIME_FORMAT;
const DISPLAY_DATE_TIME_FORMAT_WITHOUT_SECONDS = process.env.REACT_APP_DISPLAY_DATE_TIME_FORMAT_WITHOUT_SECONDS;
const ROOT_PIN = process.env.REACT_APP_ROOTPIN;

const LOGO_PATH: string = process.env.REACT_APP_LOGO || '';
const LOGO_MOBILE_PATH: string = process.env.REACT_APP_LOGO_MOBILE || '';
const LOGO_MOBILE_DARK_PATH: string = process.env.REACT_APP_LOGO_MOBILE_DARK || '';
const CLIENT_NAME: string = process.env.REACT_APP_CLIENT_NAME || '';
const RISK_TICKET_TIMEOUT_SECONDS: number =
  Number(process.env.REACT_APP_RISK_TICKET_TIMEOUT_SECONDS) || 180;
const BETROYAL_PREMATCH_RISK_TICKET_TIMEOUT_SECONDS = 60;
const LIVE_RISK_TICKET_TIMEOUT_SECONDS = 45;

export {
  NODE_ENV,
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  DISPLAY_DATE_FORMAT,
  DISPLAY_DATE_TIME_FORMAT,
  DISPLAY_DATE_TIME_FORMAT_WITHOUT_SECONDS,
  ROOT_PIN,
  LOGO_PATH,
  LOGO_MOBILE_PATH,
  LOGO_MOBILE_DARK_PATH,
  CLIENT_NAME,
  RISK_TICKET_TIMEOUT_SECONDS,
  BETROYAL_PREMATCH_RISK_TICKET_TIMEOUT_SECONDS,
  LIVE_RISK_TICKET_TIMEOUT_SECONDS,
};







